import React, { createContext, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RouteContants from "../../constants/routesContent.json";
import {
  getPermissionsList,
  getRoleList,
  updatePermissionsList,
  visitorMagneticCardApi,
  visitorCardExcel,
  addExtentedStay,
  getextentedValue
} from "../../api/Api";
import CheckBox from "../../components/CheckBox/CheckBox";

export const SettingsPermissionContext = createContext({});

export const SettingsPermissionContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [rolesList, setRolesList] = useState();
  const [rolesNames, setRolesNames] = useState();
  const [tableData, setTableData] = useState();
  const [cardFileDownload, setCardFileDownload] = useState();
  const [currentlySelected, setCurrentlySelected] = useState({
    status: false,
    data: {},
  });
  const [updatedFeaturesAndPermissions, setUpdatedFeaturesAndPermissions] =
    useState([]);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [cardExcel, setCardExcel] = useState(null);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [cardFile, setCardFile] = useState(null);
  // new change
  const [extentendStayValue, setExtentendStayValue] = useState("Select");
  const [extentedStayRequired, setExtentedStayRequired] = useState(false);
  const [extentedSpinnerStatus, setExtentedSpinnerStatus] = useState(false);
  const navigateToRoleManagement = () => {
    navigate(RouteContants.SETTINGS_ROLE_MANAGEMENT);
  };

  const navigateToDeviceSettings = () => {
    
    navigate(RouteContants.SETTINGS);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContants.LOGIN);
  };

  const goBack = () => {
    navigate(-1);
  };

  const callGetVisitorCardExcel = async () => {
    setSpinnerStatus(true);
    try {
      const getExcel = await visitorCardExcel();
      if (getExcel.status === 200) {
        setSpinnerStatus(false);
        setCardFileDownload(getExcel.data.data.filename);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const updatePermission = () => {
    setShowAlert(true);
  };

  /**
   * Load the roles list and add the title
   */
  const loadRolesList = async () => {
    try {
      const response = await getRoleList();
      const names = response?.data?.data?.roles.map((item) => {
        return { title: item.RoleName, prop: item.RoleName };
      });
      setRolesList(response?.data?.data?.roles);
      setRolesNames([
        { title: "Permissions", prop: "permissionTitle" },
        ...names,
      ]);
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error.response.data.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  /**
   * This function loads the table with roles and permissions along with check boxes
   */
  const loadPermissionsList = async () => {
    setExtentedSpinnerStatus(true);
    //Get the permissions list
    const response = await (await getPermissionsList()).data.data;
    setExtentedSpinnerStatus(false);
    const letPermissionsObject = [];
    //The permissions list to load on the table
    const permissionsValues = response?.map((item, index) => {
      //Get the corresponding role array
      const rolesObject = rolesList?.map((role) => {
        const selectedRoleStatus = item?.role?.find((value) => {
          return value.roleName === role.RoleName;
        });

        const defaultSelectedStatus = selectedRoleStatus.status
          ? selectedRoleStatus.status
          : false;
        if (defaultSelectedStatus) {
          letPermissionsObject.push({
            role: role.RoleId,
            permission: item.permissionId,
          });
        }

        const customIdForTracking =
          role.RoleName + "-$-" + item.permissionTitle;
        //Assign check box to the role and load the initial status
        return {
          [role.RoleName]: (
            <CheckBox
              value={
                selectedRoleStatus.status ? selectedRoleStatus.status : false
              }
              id={customIdForTracking}
              onClick={(e) => {
                setCurrentlySelected({
                  data: {
                    role: role.RoleId,
                    permission: item.permissionId,
                  },
                  status: e.status,
                });
              }}
            />
          ),
        };
      });

      const reIteratedObject = {};
      //Bring all the individual values to a single object
      rolesObject?.map((item) => {
        reIteratedObject[Object.keys(item)] = item[Object.keys(item)];
      });
      return {
        permissionTitle: item?.permissionTitle,
        ...reIteratedObject,
      };
    });

    setUpdatedFeaturesAndPermissions(letPermissionsObject);
    //Add an extra title as permissions, where the all feature/ permissions will display in the uI
    setTableData([...permissionsValues]);
  };

  const submitUpdatedData = async () => {
    try {
      setSpinnerStatus(true);
      const response = await updatePermissionsList({
        permissions: updatedFeaturesAndPermissions?.map((item) => {
          return {
            featureId: item?.permission,
            roleId: item?.role,
          };
        }),
      });
      if (response?.data?.status === 200) {
        setShowAlert(true);
        setAlertMessage(response?.data?.message);
        setSpinnerStatus(false);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    if (currentlySelected) {
      if (currentlySelected.status) {
        setUpdatedFeaturesAndPermissions([
          ...updatedFeaturesAndPermissions,
          currentlySelected.data,
        ]);
      } else {
        let newArray = updatedFeaturesAndPermissions.filter((item) => {
          if (
            item.role === currentlySelected.data.role &&
            item.permission === currentlySelected.data.permission
          ) {
            return false;
          }
          return true;
        });
        setUpdatedFeaturesAndPermissions(newArray);
      }
    }
  }, [currentlySelected]);

  useEffect(() => {
    loadRolesList();
  }, []);

  /**
   * Load the permissions list only after roles list is fetched
   */
  useEffect(() => {
    loadPermissionsList();
  }, [rolesList]);

  // file upload validation
  const handleCardValidation = (value) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!value) {
      setFileErrorMessage("Upload .xlsx file");
      return false;
    } else if (!allowedTypes.includes(value.type)) {
      setFileErrorMessage("Please upload .xlsx file");
      return false;
    }
    // else if (value.size > maxSizeInBytes) {
    //   setImageErrorMessage(pageContent.imageSizeValidationMessage);
    //   return false;
    // }
    else {
      setFileErrorMessage("");
      return true;
    }
  };

  const handleAlertSubmit = () => {
    setShowAlert(false);
  };

  const handleMagneticUpload = (event) => {
    setCardFile(event?.target?.files[0]);
    setCardExcel(event?.target?.files[0]?.name);
  };
  const editvistorData = () => {
    let formData = new FormData();
    formData.append("visitorCard", cardFile);

    return formData;
  };

  const visitorCardSubmit = async (e) => {
    e.preventDefault();
    const cardData = {
      visitorCard: cardFile,
    };
    const fileData = handleCardValidation(cardFile);

    if (fileData) {
      setSpinnerStatus(true);
      try {
        const file = await visitorMagneticCardApi(editvistorData(), cardData);

        if (file?.data?.status === 200) {
          setSpinnerStatus(false);
          setShowAlert(true);
          setAlertMessage(file?.data?.message);
          setCardExcel(null);
          setCardFile(null);
        }
      } catch (error) {
        setSpinnerStatus(false);
        setStatusCode(error?.response?.data?.status);
        if (
          error?.response?.data?.status === 401 ||
          error?.response?.data?.status === 400 ||
          error?.response?.data?.status === 403
        ) {
          const errorMessage = error?.response?.data?.message;
          setShowAlert(true);
          setAlertMessage(errorMessage);
        } else {
          setShowAlert(true);
          setAlertMessage("Something went wrong");
        }
      }
    }
  };
  useEffect(() => {
    callGetVisitorCardExcel();
    getExtentedStayValue()
  }, []);
  
  const submitExtentedStayData = async (e) => {
    setExtentedSpinnerStatus(true);
    e.preventDefault();
    if (extentendStayValue === 'Select'){
      setExtentedStayRequired(true);
      setExtentedSpinnerStatus(false);
      setShowAlert(true);
      setAlertMessage("Please select an extended stay");
       
     }else{
      setExtentedStayRequired(false);
      setExtentedSpinnerStatus(true);
      setShowAlert(false);
     
     
  
    const extentedData = {
      extendedStay: extentendStayValue.name ? extentendStayValue.name :extentendStayValue,
    };
   // setExtentedSpinnerStatus(true);
    try {
      const extentedResponse = await addExtentedStay(extentedData);
      if (extentedResponse.status === 200) {
        
        setAlertMessage("Extented stay configuration time updated successfully");
        setExtentedSpinnerStatus(false);
        setShowAlert(true);
     
      }
    } catch (error) {
      setExtentedSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  }
  };
  const getExtentedStayValue = async () =>{
    setExtentedSpinnerStatus(true);
    try {
      const extentedResponse = await getextentedValue();
     
      if (extentedResponse.status === 200) {
        setExtentedSpinnerStatus(false);
        setExtentendStayValue(extentedResponse.data.data.stayHour)
      }
    } catch (error) {
      setExtentedSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  }

  const providerValue = {
    navigateToDeviceSettings,
    navigateToRoleManagement,
    goBack,
    showAlert,
    setShowAlert,
    updatePermission,
    rolesNames,
    tableData,
    submitUpdatedData,
    handleAlertSubmit,
    spinnerStatus,
    alertMessage,
    setAlertMessage,
    logout,
    statusCode,
    handleMagneticUpload,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    cardFileDownload,
    //new chanhe
    extentendStayValue, setExtentendStayValue,
    submitExtentedStayData,
    setExtentedStayRequired,setSpinnerStatus,
    getExtentedStayValue,
    setExtentedSpinnerStatus,extentedSpinnerStatus,
    
  };

  return (
    <SettingsPermissionContext.Provider value={providerValue}>
      {children}
    </SettingsPermissionContext.Provider>
  );
};
